import { TFunction } from 'i18next';
import { REGULARS } from 'utils';

export function validateExtremeOrQuestion(
	text: string,
	t: TFunction,
): {
	text: string;
	error?: string;
} {
	let error: string = '';

	if (text.length < 5) {
		error = t('should_not_be_less_length', {
			minValue: 5,
		});
	}

	if (!text) {
		error = t('required');
	}

	return {
		text: text.replace(REGULARS.exceptLettersNumbersSpace, ''),
		error,
	};
}
